
<component :is="currentTag" class="fr-view"></component>
